import React, { useState } from 'react';
import Button from '../../Button/Button';
import { ChevronDown } from 'lucide-react';

/**
 * FormSection - Molecular component for collapsible form sections
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 * @param {boolean} props.collapsible - Whether section can be collapsed
 * @param {boolean} props.isOpen - Controlled open state
 * @param {Function} props.onToggle - Callback when toggled
 * @param {string} props.className - Additional CSS classes
 */
export const FormSection = ({
    title,
    children,
    collapsible = false,
    isOpen: controlledIsOpen,
    onToggle,
    className = ''
}) => {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;

    const handleToggle = () => {
        if (onToggle) {
            onToggle(!isOpen);
        } else {
            setInternalIsOpen(!isOpen);
        }
    };

    if (!collapsible) {
        return (
            <div className={`flex flex-col gap-2.5 ${className}`}>
                {title && <h3 className="text-sm font-medium text-neutral-green-600">{title}</h3>}
                {children}
            </div>
        );
    }

    return (
        <div className={`flex flex-col ${className}`}>
            <Button
                type="button"
                variant="link"
                size="xs"
                className="px-0 font-bold justify-start"
                onClick={handleToggle}
                leftIcon={
                    <ChevronDown
                        className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    />
                }
            >
                {title}
            </Button>
            {isOpen && (
                <div className="flex flex-col gap-2.5 mt-2">
                    {children}
                </div>
            )}
        </div>
    );
};

export default FormSection;
